import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { card, input, label, btnPrimary, fmtDate } from "../ui";
import { Plus, Trash2, Calendar } from "lucide-react";

const today = () => new Date().toISOString().slice(0, 10);

export default function Evolutions({ patientId }) {
  const [items, setItems] = useState([]);
  const [date, setDate] = useState(today());
  const [content, setContent] = useState("");
  const [saving, setSaving] = useState(false);

  const load = () => api.get(`/patients/${patientId}/evolutions`).then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, [patientId]);

  const add = async () => {
    if (!content.trim()) return toast.error("Escreva a evolução da sessão.");
    setSaving(true);
    try {
      await api.post(`/patients/${patientId}/evolutions`, { date, content });
      toast.success("Evolução registrada.");
      setContent(""); setDate(today());
      load();
    } catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  const del = async (eid) => {
    if (!window.confirm("Excluir este registro de evolução?")) return;
    await api.delete(`/evolutions/${eid}`);
    toast.success("Registro excluído.");
    load();
  };

  return (
    <div className="grid gap-6 lg:grid-cols-[340px_1fr]">
      <div className={`${card} p-6 h-fit`} data-testid="evolution-form">
        <p className="font-display text-xl text-[#2C332A] mb-4">Nova evolução</p>
        <label className={label}>Data da sessão</label>
        <input type="date" className={input} value={date} onChange={(e) => setDate(e.target.value)} data-testid="evolution-date" />
        <label className={`${label} mt-4`}>Evolução / anotações</label>
        <textarea rows={6} className={`${input} resize-none`} value={content} onChange={(e) => setContent(e.target.value)} placeholder="Como foi a sessão, temas trabalhados, evolução observada..." data-testid="evolution-content" />
        <button className={`${btnPrimary} w-full mt-4`} onClick={add} disabled={saving} data-testid="evolution-add"><Plus className="w-4 h-4" /> Adicionar</button>
      </div>

      <div className="space-y-4" data-testid="evolution-list">
        {items.length === 0 && <p className="font-body text-sm text-[#7A8A7A]">Nenhuma evolução registrada ainda.</p>}
        {items.map((e) => (
          <div key={e.id} className={`${card} p-5`} data-testid="evolution-item">
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center gap-2 font-body text-sm font-medium text-[#4A5D4E]"><Calendar className="w-4 h-4 text-[#C87A5E]" /> {fmtDate(e.date)}</span>
              <button onClick={() => del(e.id)} className="text-[#C87A5E] hover:text-[#B2644D]" data-testid="evolution-delete"><Trash2 className="w-4 h-4" /></button>
            </div>
            <p className="font-body text-sm text-[#2C332A] mt-3 whitespace-pre-line leading-relaxed">{e.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
